import type { ReactNode } from 'react';
import { useSessionRestore } from '@/features/auth';

/** Restores the session from the refresh cookie before the router renders anything. */
export function SessionProvider({ children }: { children: ReactNode }) {
  useSessionRestore();
  return <>{children}</>;
}
